import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Geocircle } from "./geocircle";
export const protobufPackage = "snapchat.lenses";
export interface Lures {
    locations: Geocircle[];
    activeLure: Geocircle | undefined;
    closestLure: Geocircle | undefined;
}
function createBaseLures(): Lures {
    return { locations: [], activeLure: undefined, closestLure: undefined };
}
export const Lures: MessageFns<Lures> = {
    encode(message: Lures, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        for (const v of message.locations) {
            Geocircle.encode(v!, writer.uint32(10).fork()).join();
        }
        if (message.activeLure !== undefined) {
            Geocircle.encode(message.activeLure, writer.uint32(18).fork()).join();
        }
        if (message.closestLure !== undefined) {
            Geocircle.encode(message.closestLure, writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): Lures {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLures();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.locations.push(Geocircle.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.activeLure = Geocircle.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.closestLure = Geocircle.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<Lures>, I>>(base?: I): Lures {
        return Lures.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<Lures>, I>>(object: I): Lures {
        const message = createBaseLures();
        message.locations = object.locations?.map((e) => Geocircle.fromPartial(e)) || [];
        message.activeLure = (object.activeLure !== undefined && object.activeLure !== null)
            ? Geocircle.fromPartial(object.activeLure)
            : undefined;
        message.closestLure = (object.closestLure !== undefined && object.closestLure !== null)
            ? Geocircle.fromPartial(object.closestLure)
            : undefined;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {
    $case: string;
} ? {
    [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]>;
} & {
    $case: T["$case"];
} : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
